import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export async function getStartForm(
  processDefinitionId: string,
): Promise<unknown> {
  const response: AxiosResponse<unknown> = await api.get(
    `/api/v1/solicitacoes/process/${processDefinitionId}/start-form`,
  );
  return response.data;
}

export async function getRequestsList(): Promise<Record<string, string>> {
  const response: AxiosResponse<Record<string, string>> =
    await api.get(`/api/v1/solicitacoes`);
  return response.data;
}

export async function getTaskForm(
  processId: string,
  taskId: string,
): Promise<unknown> {
  const response: AxiosResponse<unknown> = await api.get(
    `/api/v1/solicitacoes/${processId}/tasks/${taskId}/form`,
  );
  return response.data;
}

export async function getTasks(processId: string): Promise<TasksType[]> {
  const response: AxiosResponse<TasksType[]> = await api.get(
    `/api/v1/solicitacoes/${processId}/tasks/history`,
  );
  return response.data;
}
